var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticStyle:{"white-space":"nowrap"},attrs:{"to":_vm.t({query: { sort: _vm.value === _vm.asc ? _vm.desc : _vm.value === _vm.desc ? _vm.asc : _vm.initial}})}},[_c('span',{class:{
		'fas': true,
		'fa-sort': _vm.value !== _vm.asc && _vm.value !== _vm.desc,
		'fa-sort-up': _vm.value === _vm.asc,
		'fa-sort-down': _vm.value === _vm.desc
	}}),_vm._v(" "+_vm._s(' ')+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }